import React, { useEffect } from 'react';
import HeroSection from '../components/Home/HeroSection';
import AboutSection from '../components/Home/AboutSection';
import ServicesSection from '../components/Home/ServicesSection';
import WhyChooseUs from '../components/Home/WhyChooseUs';
import CounterSection from '../components/Home/CounterSection';
// Change this in Home.jsx:
import ClientsLogos from '../components/Home/ClientsLogos';


 

const Home = () => {
  useEffect(() => {
    document.title = 'Pentagram Infotech - Leading IT Solutions Provider';
    document.querySelector('meta[name="description"]')?.setAttribute('content', 
      'Pentagram Infotech offers comprehensive IT services including cloud computing, cybersecurity, software solutions, and IT support. Transform your business with our expertise.'
    );
  }, []);

  return (
    <div className="home-page">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUs />
     <ClientsLogos />
      <CounterSection />
    </div>
  );
};

export default Home;